import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import chainLogo from '../../assets/images/chain-logo.png';

const GREEN = '#2e7d32';
const RED = '#c62828';

export default function EmailVerifiedPage() {
  const status = new URLSearchParams(window.location.search).get('status');
  const success = status === 'success';
  const accent = success ? GREEN : RED;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{
        background: '#f0f2f5',
        backgroundImage:
          'radial-gradient(circle at 20% 20%, rgba(46,125,50,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(46,125,50,0.06) 0%, transparent 50%)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 440,
          width: '90%',
          borderRadius: 4,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'rgba(0,0,0,0.08)',
          boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
        }}
      >
        {/* Accent top bar */}
        <Box sx={{ height: 6, background: `linear-gradient(90deg, ${accent} 0%, ${success ? '#66bb6a' : '#ef5350'} 100%)` }} />

        {/* Logo + brand */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 4,
            pb: 2,
            gap: 1,
            borderBottom: '1px solid',
            borderColor: 'rgba(0,0,0,0.06)',
            backgroundColor: '#fff',
          }}
        >
          <Box
            component="img"
            src={chainLogo}
            alt="PontuaX"
            sx={{
              height: 52,
              objectFit: 'contain',
              borderRadius: 2,
            }}
          />
          <Typography
            variant="subtitle2"
            fontWeight={600}
            letterSpacing={1.5}
            sx={{ color: 'text.disabled', textTransform: 'uppercase', fontSize: 11 }}
          >
            PontuaX Admin
          </Typography>
        </Box>

        {/* Body */}
        <Box
          px={4}
          pt={4}
          pb={3.5}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          sx={{ backgroundColor: '#fff' }}
        >
          {/* Icon badge */}
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              backgroundColor: success ? 'rgba(46,125,50,0.08)' : 'rgba(198,40,40,0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {success
              ? <CheckCircleIcon sx={{ fontSize: 40, color: GREEN }} />
              : <ErrorIcon sx={{ fontSize: 40, color: RED }} />}
          </Box>

          <Typography variant="h6" fontWeight={700} textAlign="center" color="text.primary">
            {success ? 'Email verificado com sucesso!' : 'Link inválido ou expirado'}
          </Typography>

          <Typography variant="body2" color="text.secondary" textAlign="center" lineHeight={1.75}>
            {success
              ? 'Sua conta foi ativada e está pronta para uso. Acesse o sistema com o login e senha que foram cadastrados pelo administrador.'
              : 'O link de verificação não é mais válido. Isso ocorre quando o link já foi utilizado anteriormente ou quando ele expirou após 24 horas da criação da conta.'}
          </Typography>

          <Divider sx={{ width: '100%', my: 0.5 }} />

          {success ? (
            <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} width="100%">
              <Typography variant="caption" color="text.disabled" textAlign="center">
                Clique no botão abaixo para acessar a página de login
              </Typography>
              <Button
                variant="contained"
                size="large"
                href="/"
                startIcon={<LoginIcon />}
                fullWidth
                sx={{
                  background: `linear-gradient(135deg, ${GREEN} 0%, #43a047 100%)`,
                  '&:hover': { background: `linear-gradient(135deg, #1b5e20 0%, ${GREEN} 100%)` },
                  borderRadius: 2,
                  py: 1.3,
                  fontWeight: 700,
                  fontSize: 14,
                  letterSpacing: 0.5,
                  boxShadow: '0 4px 12px rgba(46,125,50,0.3)',
                }}
              >
                Ir para o login
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'rgba(198,40,40,0.05)',
                border: '1px solid rgba(198,40,40,0.15)',
                borderRadius: 2,
                px: 2.5,
                py: 1.5,
              }}
            >
              <Typography variant="body2" color="error" textAlign="center" fontWeight={500}>
                Entre em contato com o administrador e solicite um novo convite de cadastro.
              </Typography>
            </Box>
          )}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            px: 4,
            py: 1.5,
            textAlign: 'center',
            backgroundColor: '#fafafa',
            borderTop: '1px solid',
            borderColor: 'rgba(0,0,0,0.06)',
          }}
        >
          <Typography variant="caption" color="text.disabled">
            © {new Date().getFullYear()} PontuaX — Todos os direitos reservados
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
